module.exports = __webpack_public_path__ + "p6_img1.jpg?e98433c68acb6bd7b0150dca89795692";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p6/p6_img1.jpg
// module id = 116
// module chunks = 0